export default function hasApiErrors(apiError) {
  const errorValues = Object.values(apiError);

  return errorValues.some((errorValue) => {
    if (!errorValue) return false;

    if (Array.isArray(errorValue)) {
      return errorValue.length > 0;
    }

    if (typeof errorValue === 'string') {
      return errorValue.trim().length > 0;
    }

    if (typeof errorValue === 'object') {
      return errorValue?.message?.length > 0;
    }

    return false;
  });
}
